import { createSelector } from '@ngrx/store';
import { selectCaseState } from './common-case.selector';

export const selectPatientInformations = createSelector(
  selectCaseState,
  (state) => state.case.patientInformations
);


export const selectPatientFullname = createSelector(
  selectCaseState,
  (state) => ({firstName:state.case.patientInformations?.firstName,lastName:state.case.patientInformations?.lastName})
);

export const selectedCase = createSelector(
  selectCaseState,
  (state) => state.case.id
);
